import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Kalish Family</p>
        <h1>Welcome to the Kalish Family Website</h1>
        <p className="lede">
          Stay connected with the Kalish family! Explore our latest updates, cherished photos, and personal stories that bring our family closer together.
        </p>
        <div className="cta-row">
          <a href="#updates" target="_self">
            View Updates
          </a>
          <a href="#gallery" target="_self" className="secondary">
            Explore Our Gallery
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Latest Updates</h2>
          <p>
            Discover what's new with the Kalish family. From milestones to everyday moments, we share our journey with you.
          </p>
        </article>
        <article>
          <h2>Family Gallery</h2>
          <p>
            Browse through our collection of family photos that capture our special moments and memories together.
          </p>
        </article>
        <article>
          <h2>Personal Stories</h2>
          <p>
            Read heartfelt stories from our family members, sharing experiences and lessons learned along the way.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;